import { iam } from '../profile';
export var isOffsetError = function isOffsetError() {
  var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return errors.find(function (e) {
    return e.message.includes('Signature expired') || e.message.includes('Signature not yet current');
  });
};
export var getGraphQLErrors = function getGraphQLErrors() {
  var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _iam = iam(),
    getAuthSession = _iam.getAuthSession;
  var _getAuthSession = getAuthSession(),
    isLoggedIn = _getAuthSession.isLoggedIn;
  var isAuthed = isLoggedIn ? 'Y' : 'N';
  return errors.map(function (_ref) {
    var message = _ref.message;
    return "".concat(isAuthed, ":").concat(message);
  }).join(',');
};
export var getGraphQLErrorMessage = function getGraphQLErrorMessage(error) {
  var _ref2 = error || {},
    message = _ref2.message,
    _ref2$networkError = _ref2.networkError,
    networkError = _ref2$networkError === void 0 ? {} : _ref2$networkError;
  var _ref3 = networkError || {},
    _ref3$result = _ref3.result,
    result = _ref3$result === void 0 ? {} : _ref3$result,
    statusCode = _ref3.statusCode;
  var formattedMsg = message ? message.replace('GraphQL error:', '').trim() : null;

  // track offset error here, because this means it reached the UI
  // offset errors will still happen
  // but the app should recover and make the request again, see client.js
  if (isOffsetError(result.errors)) {
    console.error(formattedMsg);
  }
  return formattedMsg;
};